import { Search, FileText, Hash } from "lucide-react";

const steps = [
  {
    number: "1",
    title: "CAMPO DE BUSCA",
    description:
      "Ao acessar o site pecasdetoyota.com.br, utilize os filtros de família, ano, de fabricação e demais filtros na parte superior da página.",
    icon: Search,
  },
  {
    number: "2",
    title: "PLACA DO VEÍCULO",
    description:
      "Insira a placa do seu veículo Toyota para encontrar as peças de maneira mais precisa.",
    icon: FileText,
  },
  {
    number: "3",
    title: "NÚMERO DA PEÇA",
    description: `Caso possua o número da peça, utilize o campo "Busque N° Peça".`,
    icon: Hash,
  },
];

export default function FindParts() {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-semibold text-gray-900 text-center mb-12">
          SAIBA COMO ENCONTRAR A PEÇA DO SEU TOYOTA
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div key={step.number} className="relative">
              <div className="bg-white rounded-lg shadow-lg p-6 h-full">
                <div className="absolute -top-6 left-6 w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  {step.number}
                </div>
                <div className="mt-6">
                  <step.icon className="w-8 h-8 text-red-600 mb-4" />
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
